import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import { translate } from "react-translate"

@translate("PropertyDetail")
export default class Description extends Component {

  constructor (props) {
    super(props)

    this.state = {
      moreInfo: false,
      property_observations: props.property.observations.trim().substr(0, 800)
    }

    this.showMoreInfo = this.showMoreInfo.bind(this);
  }

  showMoreInfo() {
    this.setState({
      moreInfo: !this.state.moreInfo,
      property_observations: !this.state.moreInfo ? this.props.property.observations.trim() : this.props.property.observations.trim().substr(0, 800)
    });
  }

  _renderAntiqui (date) {
    var d = moment(date, "DD-MM-YYYY");
    let years = moment().diff(d, 'years', false)
    return years
  }

  _renderCategory (id, categories) {
    let category = categories.filter(c => parseInt(c.id) === id);
    return (category.length > 0) ? category[0].name : ''
  }

  _renderUses(id, uses) {
    let use = uses.filter(function (c) {
      return parseInt(c.id) === id;
    });
    return use = (use.length > 0) ? use[0].name : ''
  }

  render() {

    const { property, categories, terrainUses, t } = this.props

    let generals = []
    let showMoreInfoButton = property.observations.trim().length > 800

    switch (property.property_type.name) {
      case 'Casa' :
      case 'Quinta':
      case 'PH':
        generals = [
                    {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
                    {value: (property.bedrooms) ? property.bedrooms : 0, name: t("Dormitorios")},
                    {value: (property.ambients) ? property.ambients : 0, name: t("Ambientes")},
                    {value: (property.covered_area) ? ( property.covered_area + ' m2') : 0, name: t("Sup_Cubierta")},
                    {value: (property.land_area) ? ( property.land_area + ' m2') : 0, name: t("Sup_Terreno")},
                    {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')}
                  ]
        break;

      case 'Departamento': //apartment
        generals = [{value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
                    {value: (property.bedrooms) ? property.bedrooms : 0, name: t("Dormitorios")},
                    {value: (property.ambients) ? property.ambients : 0, name: t("Ambientes")},
                    {value: (property.land_area) ? ( property.covered_area + ' m2') : 0, name: t("Sup_Cubierta")},
                    {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')},
                  ]
        break;

      case "Nave Industrial":
      case "Depósito":
      case "Galpón": //industry
        generals = [
                    {value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.nave) ? property.nave : 0, name: t("Cant_Naves")},
                    {value: (property.covered_area) ? ( property.covered_area + ' m2') : 0, name: t("Sup_Cubierta")},
                    {value: (property.land_area) ? ( property.land_area + ' m2') : 0, name: t("Sup_Terreno")},
                    {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')},
                  ]

        break;

      case "Chacra":
      case "Campo":
      case "Finca": //fields
        generals = [{value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.land_area) ? parseInt(property.land_area)/10000 : 0, name: t("Hectareas")},
                    {value: (property.aptitude && property.aptitude.length > 0) ? property.aptitude[0].name : 0, name: t("Aptitud")},
                    {value: (property.zone) ? property.zone.name : 0, name: t("Zona")},]

        break;

      case "Hotel" : //hotels
        generals = [{value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.category) ? (this._renderCategory(property.category, categories)) : 0, name: t("Categoria")},
                    {value: (property.rooms > 0) ? 
                      property.rooms : property.bedrooms ? property.bedrooms : 0, name: t("Cant_Habitaciones")},
                    {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')}]
        break;

      case "Local":
      case "Edificio Comercial":
      case "Fondo de Comercio": //retail
        generals = [
                    {value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.situation) ? property.situation : 0, name: t("Situacion")},
                    {value: (property.covered_area) ? ( property.covered_area + ' m2') : 0, name: t("Sup_Cubierta")},
                    {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')}]
        break;

      case "Terreno": //terrenos
        generals = [{value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.land_area) ? ( property.land_area + ' m2') : 0, name: t("Sup_Terreno")},
                    {value: (property.orientation) ?  property.orientation  : 0, name: t("Orientacion")},
                    {value: (property.land_use) ?  (this._renderUses(property.land_use, terrainUses))  : 0, name: t("Uso_Terreno")},
                    {value: (property.fot) ? property.fot : 0, name: 'FOT'}]
        break;

      case "Oficina": case "Edificio Comercial": //office/buildings
        generals = [{value: (property.zonification) ? property.zonification : 0, name: t("Zonificacion")},
                    {value: (property.category) ? (this._renderCategory(property.category, categories)) : 0, name: t("Categoria")},
                    {value: (property.garages) ? property.garages: 0, name: t("Cocheras")},
                    {value: (property.covered_area) ? ( property.covered_area + t("M2")) : 0, name: t("Sup_Cubierta")},
                    {value: (property.antiquity && property.antiquity !== -1) ? (property.antiquity + t('Anios')) : (property.antiquity === -1) ? t('En_construccion') : '', name: t('Antiguedad')}]
    }

    return (
      <div className="caracteristics-container hidden-xs">
        <div className="col-md-6 col-sm-6">
          <h3>Características de la Propiedad</h3>
          <div className="description-full">
            <p>{this.state.property_observations}</p>
          </div>
          {(showMoreInfoButton) ? (
            (this.state.moreInfo) ? (
                <Button bsStyle="link" className="btn-ver" onClick={() => this.showMoreInfo()}> {t("Ver_Menos")} </Button>
              ) : (
                <Button bsStyle="link" className="btn-ver" onClick={() => this.showMoreInfo()}> {t("Ver_Mas")} </Button>
              )
            ) : ('')
          }
        </div>
        {(generals.length > 0) ? (
          <div className="col-md-6 col-sm-6 col-right">
            <div className="box-caracteristics">
              <div className="column-zone">
                {generals.map((item, index) =>
                  ((item.value !== 0) && (item.value !== "")) ? (
                    <div className="box-info" key={index}>
                      <h4>{item.name}</h4>
                      <p>{item.value}</p>
                    </div>
                  ) : ''
                )}
              </div>
            </div>
          </div>
        ) : '' }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/description.js